import React from 'react'
import { ThemeProvider } from '@emotion/react'

const theme = {
  "id": 147,
  "colors": {
    "colorVariable1": "rgb(96, 114, 107, 1)",
    "colorVariable2": "rgba(21, 29, 37, 1)",
    "colorVariableBtn1": "rgb(226, 228, 235)",
    "colorVariableBtn2": "rgb(28, 31, 39)",
    "front1": "rgba(232,232,232,1)",
    "front2": "rgba(255,255,255,1)",
    "back2": "rgba(0,0,0,1)"
  },
  "variables": {
    "color-variable-1": "rgb(96, 114, 107, 1)",
    "color-variable-2": "rgba(21, 29, 37, 1)",
    "color-variable-btn-1": "rgb(226, 228, 235)",
    "color-variable-btn-2": "rgb(28, 31, 39)"
  },
  "globalMobile": "27em",
  "meta": []
}

export default function ThemeWrapper(props) {
  return (
    <ThemeProvider theme={theme}>
      {props.children}
    </ThemeProvider>
  )
}